// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-tabs .nav-link,.nav-tabs .nav-link.active{color:var(--colors-gray-500);border:0;border-bottom:3px solid transparent;background-color:transparent;font-size:var(--text-lg);font-weight:500;border-radius:0}.nav-tabs .nav-link:focus-visible{box-shadow:var(--button-focus-shadow);border-radius:var(--radius-1px)}.nav-tabs .nav-link.active{color:inherit;border-color:var(--colors-brand)}\n", ""]);
// Exports
module.exports = exports;
